<template>

    <v-container justify-start >
      <span><router-link :to="{name:'Проекты'}">Проекты</router-link></span> <span>/<b> Пополнение счета </b></span>

      <v-divider class="mt-3"></v-divider>

      <h2> Реквизиты для пополнения счета </h2>

      <v-layout row wrap mb-2 >
       <v-flex class="xs12 md9">
          <v-card class="elevation-1">
            <v-card-title>
                <h4>Реквизиты</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Получатель:</v-list-tile-content>
                  <v-list-tile-content class="align-end">ООО "Организация"</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>ИНН:</v-list-tile-content>
                  <v-list-tile-content class="align-end">565845384529</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>БИК:</v-list-tile-content>
                  <v-list-tile-content class="align-end">38473847</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Банк:</v-list-tile-content>
                  <v-list-tile-content class="align-end">филиал Сбербанка г.Оренбург</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>р/с:</v-list-tile-content>
                  <v-list-tile-content class="align-end">2342342734676722</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Назначение платежа:</v-list-tile-content>
                  <v-list-tile-content class="align-end">Пополнение лицевого счета №<b>182878</b></v-list-tile-content>
                </v-list-tile>
            </v-list>

          </v-card>
        </v-flex>
        <v-flex class="xs12 md8" my-4>
          <v-card class="elevation-1">
            <v-card-title>
                <h4>тест</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field v-model="sum" label="Сумма" type="number" required></v-text-field>
                </v-flex>
                <v-flex xs10 sm8 md4>
                  <v-btn color="success" @click="fund()">Пополнить</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- snackbar -->
      <v-snackbar
      :timeout="6000"
      :top="true"
      :bottom="false"
      :right="true"
      :left="false"
      :multi-line="false"
      :vertical="true"
      v-model="snackbar"
      >
        {{ message }}
        <v-btn flat color="pink" @click.native="snackbar = false">Закрыть</v-btn>
      </v-snackbar>
      <!-- spiner -->
      <div class="overlay" v-if="inProgress">
          <div class="flex-spinner">
            <v-progress-circular :size="200" :width="7" indeterminate color="amber"></v-progress-circular>
          </div>
      </div>

    </v-container>
</template>

<script>

export default {
   components:{
  },
    created () {
    },
    mounted () {
    },
    computed: {
    },
    data () {
        return {
          sum:0,
          inProgress: false,
          message: '',
          snackbar: false
        }
    },
    methods: {
      fund() {
        console.log('fund',this.sum);
        this.inProgress = true
        this.$store.dispatch("account/addBalance",this.sum).then((res)=>{
          console.log('success',res);
          this.message = 'Баланс пополнен'
          this.snackbar = true
          this.sum = 0
          this.inProgress = false
        }).catch((err)=>{
          console.log('error',err);
          this.message = 'Ошибка пополнения'
          this.inProgress = false
          this.snackbar = true
        })
      }
    }
}
</script>

<style scoped>
    /*stylesheets*/
</style>



// WEBPACK FOOTER //
// AccountFund.vue?6e17a315